import { useEffect } from 'react';
import { Center, Loader } from '@mantine/core';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CenteredCard } from '../components/CenteredCard';
import { useAuth } from '../auth/AuthContext';

/** Cognito hosted-UI redirect target (implicit grant → `#id_token=...` in the URL
 * hash). Parses the token via AuthContext then hands off to /login, which shows the
 * tenant picker once a token is present. */
export const Route = createFileRoute('/auth-callback')({
  component: AuthCallbackPage,
});

function AuthCallbackPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Runs once on mount — this route only ever exists to consume the redirect.
    auth.completeCognitoCallback();
    void navigate({ to: '/login', replace: true });
  }, []);

  // Shares CenteredCard with /login (2026-08-25) rather than a bare
  // Center+Loader: this page is only on screen for a redirect's blink, but a
  // plain unstyled loader against bare body reads as a broken page rather
  // than a step in the same flow — same background/card/logo, just no title
  // interaction, so the handoff to /login doesn't visibly "jump" styles.
  return (
    <CenteredCard title="Signing you in" subtitle="Completing sign-in…">
      <Center py="lg">
        <Loader />
      </Center>
    </CenteredCard>
  );
}
